import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  toolLength: 0,
  tool: [],
}

export default function toolReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_TOOL:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_TOOL:
      return {...state, saveLoader: action.payload}
    case actions.GET_TOOL:
      return {...state, tool: action.payload.tool, toolLength: action.payload.toolLength}
    default:
      return {...state};
  }
}